import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {withRouting} from '../util/Routing';

import ThreadFileUploadList from './ThreadFileUploadList';

import styles from './ThreadFileUpload.module.css';
import {threadAddUploadFile, threadClearUploadFiles, threadRemoveUploadFile} from '../../redux/actions';
import {connect} from 'react-redux';
import {isThreadFileLoading} from '../../redux/selectors';

const FILE_UPLOAD_LIMIT = 1.5e+7;

class ThreadFileUpload extends Component {

    constructor(props) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
        this.onClearFiles = this.onClearFiles.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);
        this.isFailed = this.isFailed.bind(this);
        this.isSuccessful = this.isSuccessful.bind(this);
    }

    onSelect(e) {
        const files = Array.from(e.target.files);

        if (files.length === 0) {
            return;
        }

        /*
         * Do nothing and alert user if at least one of uploaded files is bigger than upload limit.
         */
        const largeFiles = files.filter((file) => file.size >= FILE_UPLOAD_LIMIT);

        if (largeFiles.length > 0) {
            alert(
                this.props.intl.formatMessage({id: 'thread.uploaded_file_too_big'})
                + largeFiles.reduce((acc, file, i) => `${acc}\n${i + 1}. ${file.name}`, "\n")
            );

            return;
        }

        const filesToUpload = files.filter((file) => typeof this.props.uploadedFiles.find((stateFile) => {return stateFile.name === file.name;}) === "undefined");
        filesToUpload.forEach(this.props.addUploadFile);
    }

    onClearFiles() {
        this.props.threadClearUploadFiles();
    }

    onRemoveFile(file) {
        this.props.threadRemoveUploadFile(file);
    }

    isSuccessful() {
        return this.props.readyState === XMLHttpRequest.DONE && this.props.status === 204;
    }

    isFailed() {
        return this.props.readyState === XMLHttpRequest.DONE && this.props.status >= 400;
    }

    render() {
        let className = styles.ready;

        if (this.props.isLoading) {
            className = styles.loading;
        }

        if (this.isFailed()) {
            className = styles.failed;
        }

        if (this.isSuccessful()) {
            className = styles.successful;
        }

        return (
            <label className={className} title={this.props.intl.formatMessage({id: 'thread.action.upload_file'})}>
                <input type="file" multiple={true} onChange={this.onSelect} value={this.props.value}/>
                <svg width="14px" height="17px" viewBox="0 0 14 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="none" strokeWidth="1" fillRule="evenodd">
                        <g transform="translate(-5.000000, -3.000000)">
                            <g transform="translate(5.000000, 3.000000)">
                                <path d="M4,13 L10,13 L10,7 L14,7 L7,0 L0,7 L4,7 L4,13 Z M0,15 L14,15 L14,17 L0,17 L0,15 Z"/>
                            </g>
                        </g>
                    </g>
                </svg>
                {this.props.uploadedFiles.size > 0
                    ? <ThreadFileUploadList files={this.props.uploadedFiles}
                                            onClear={this.onClearFiles}
                                            onRemove={this.onRemoveFile}/>
                    : null
                }
            </label>
        );
    }
}

export default withRouting(connect(
    (state) => {
        return {
            value: state.getIn(['threadFileUploadMeta', 'value']),
            status: state.getIn(['threadFileUploadMeta', 'status']),
            readyState: state.getIn(['threadFileUploadMeta', 'readyState']),
            isLoading: isThreadFileLoading(state),
            files: state.getIn(['threadFileUploadMeta', 'files'])
        };
    },
    (dispatch) => ({
        addUploadFile(file) {
            dispatch(threadAddUploadFile(file))
        },
        threadClearUploadFiles() {
            dispatch(threadClearUploadFiles())
        },
        threadRemoveUploadFile(file) {
            dispatch(threadRemoveUploadFile(file));
        },
    })
)(injectIntl(ThreadFileUpload)));
